<div class="info-panel p-2 pe-3" [class.info-panel-disabled]="type === 'disabled'"
     [style.background-color]="bgColor"
     fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
  <div>
    <mat-icon [class]="getPanelType().icon">error</mat-icon>
  </div>
  <span class="info-panel-text">{{message}}</span>
</div>
